export const convertirUserContact = (objetoEntrada: $TSMigrationFixMe) => {
  const objetoSalida = {
    ajustesDocumentoPorDefectoContacto:
      objetoEntrada.ajustesDocumentoPorDefectoContacto || [],
    cif: objetoEntrada.nif || "",
    cp: objetoEntrada.direccion?.codigoPostal || "",
    cuentasBancarias: objetoEntrada.cuentasBancarias || [],
    direccion: objetoEntrada.direccion?.calle || "",
    divisa: objetoEntrada.divisa || "",
    email:
      objetoEntrada.emails && objetoEntrada.emails.length > 0
        ? objetoEntrada.emails[0]?.contacto
        : "",
    emails: objetoEntrada.emails || [],
    empresaContactoId: objetoEntrada.empresaContactoId || "",
    empresaId: objetoEntrada.empresaId || "",
    etiquetas: objetoEntrada.etiquetas || [],
    id: objetoEntrada.id || "",
    nif: objetoEntrada.nif || "",
    pais: objetoEntrada.pais || "",
    poblacion: objetoEntrada.direccion?.poblacionNombre || "",
    poblacionExtranjera: objetoEntrada.direccion?.poblacionExtranjera || null,
    poblacionId: objetoEntrada.direccion?.poblacionId || null,
    provincia: objetoEntrada.direccion?.provinciaNombre || "",
    razonSocial: objetoEntrada.razonSocial || "",
    telefonos: objetoEntrada.telefonos || [],
    telefono:
      objetoEntrada.telefonos && objetoEntrada.telefonos.length > 0
        ? objetoEntrada.telefonos[0]?.contacto
        : "",
  }

  return objetoSalida
}
